// extracted by mini-css-extract-plugin
export default {"wrapper":"fallback-loader_wrapper__rYywa"};